/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ScheduleStatus {
    OPEN = 'OPEN',
    PENDING_APPROVAL = 'PENDING_APPROVAL',
    ASSIGNED = 'ASSIGNED',
    CANCELLED = 'CANCELLED',
}